export default function ProfileModal({ user, authEnabled, onLogout, onClose }) {
  if (!user) return null

  const fullName = `${user.last_name || ''}${user.first_name || ''}`.trim() || '(이름 없음)'
  // KBNL-119: 권한 3종 표기 — Davis 일반/Admin + SVStudio Admin 여부.
  // KBNL-129: D1 승계 폐지 — SVS Admin 은 is_svs_admin 직접 플래그만 인정.
  const isSvsAdminDirect = !!user.is_svs_admin
  const isSvsAdminEffective = isSvsAdminDirect
  const pill = (active, color) => ({
    display: 'inline-block', padding: '2px 8px', borderRadius: 999,
    fontSize: 12, fontWeight: 600, lineHeight: '18px',
    color: active ? '#fff' : 'var(--text-dim, #6b7280)',
    background: active ? color : 'transparent',
    border: `1px solid ${active ? color : 'var(--border, #d1d5db)'}`,
  })

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-title">
          <span>내 프로필</span>
          <button className="btn-icon" onClick={onClose}>✕</button>
        </div>

        <div className="profile-body">
          <div className="profile-row">
            <span className="profile-label">사번</span>
            <span className="profile-value">{user.user_id || '-'}</span>
          </div>
          <div className="profile-row">
            <span className="profile-label">성명</span>
            <span className="profile-value">{fullName}</span>
          </div>
          <div className="profile-row">
            <span className="profile-label">이메일</span>
            <span className="profile-value">{user.email || '-'}</span>
          </div>
          <div className="profile-row">
            <span className="profile-label">권한</span>
            <span className="profile-value" style={{ display: 'inline-flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
              {/* Davis 권한: Admin 이면 보라 뱃지, 아니면 일반 사용자 */}
              <span style={pill(true, user.is_admin ? '#7c3aed' : '#6b7280')}>
                {user.is_admin ? 'Davis Admin' : 'Davis 일반 사용자'}
              </span>
              {/* SVStudio Admin: 직접 부여 or Davis Admin 승계 */}
              <span
                style={pill(isSvsAdminEffective, '#16a34a')}
                title={isSvsAdminEffective ? 'SVStudio Admin 권한이 직접 부여됨' : 'SVStudio Admin 권한 없음'}
              >
                SVStudio Admin {isSvsAdminEffective ? '✓' : '✕'}
              </span>
            </span>
          </div>
          <div className="profile-row">
            <span className="profile-label">인증 모드</span>
            <span className="profile-value">{authEnabled ? '활성 (JWT)' : '비활성 (익명)'}</span>
          </div>
        </div>

        <div className="modal-footer">
          {authEnabled ? (
            <button className="btn-primary" onClick={onLogout}>로그아웃</button>
          ) : (
            <button className="btn-secondary" onClick={onClose}>닫기</button>
          )}
        </div>
      </div>
    </div>
  )
}
